import * as TYPES from './user-profile-actiontypes';

export const userPreferenceSet = (name, value) => (
  {
    type: TYPES.USER_PREFERENCE_SET,
    name,
    value,
  }
);

export const userProfileLoadedSuccess = (userData) => {
  let preferences = null;
  if (userData.userPreferences) {
    preferences = {};
    userData.userPreferences.forEach((pref) => { preferences[pref.name] = pref.value; });
  }

  let isAuthorizedRepresentative = null;
  if (userData.isAuthorizedRepresentative) {
    isAuthorizedRepresentative = userData.isAuthorizedRepresentative;
  } else if (userData.ids) {
    isAuthorizedRepresentative = userData.ids.some((id) => id.idType === 'PatientContact');
  }

  const state = {
    email: userData.email,
    firstName: userData.firstName,
    lastName: userData.lastName,
    userId: userData.userId,
    isEmailConfirmed: userData.isEmailConfirmed,
    isEulaAccepted: userData.isEulaAccepted,
    userProfileLoaded: true,
    isPasswordUpdateRequired: userData.isPasswordUpdateRequired || false,
    isAuthorizedRepresentative,
    termsOfUse: null,
  };

  if (preferences) {
    state.preferences = preferences;
  }

  return {
    type: TYPES.USER_PROFILE_LOADED_SUCCESS,
    state,
  };
};

export const termsOfUseLoadedSuccess = (termsOfUse) => (
  {
    type: TYPES.TERMSOFUSE_LOADED_SUCCESS,
    termsOfUse,
  }
);
